import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Agency } from '../../models/agency.model';
import { ApiService } from '../../services/api.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import Keycloak from 'keycloak-js';

@Component({
  selector: 'app-header',
  imports: [NgClass, NgOptimizedImage, FormsModule, RouterLink],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header implements OnInit {
  email: string | null = null;
  agRealm: string | null = null;
  currentAgency?: Agency;
  agencies: Agency[] = [];
  query: string = '';
  queryError: string = '';

  constructor(
    private apiService: ApiService,
    public authService: AuthService,
    private ls: LocalStorageService,
    private toastr: ToastrService,
    private router: Router,
    protected keycloak: Keycloak,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.email = this.keycloak.tokenParsed?.['email'];
    this.agRealm = this.ls.getItem('agRealm');
    this.initUserDataSubscription();
    this.displayStoredNotification();
  }

  private initUserDataSubscription(): void {
    this.authService.isUserDataReceived$.subscribe(() => {
      this.getAgencies();
    });
  }

  getAgencies(): void {
    this.apiService.getAgencies().subscribe({
      next: (agencies: Agency[]) => {
        if (agencies?.length) {
          this.currentAgency = agencies.find(
            (agency: Agency) => agency.id === this.ls.getItem('agencyID')
          );

          this.agencies = agencies
            .filter(agency => agency.role === 'manager')
            .sort((a: Agency, b: Agency) => {
              if (a.id === this.currentAgency?.id) return -1;
              if (b.id === this.currentAgency?.id) return 1;
              return a.name.localeCompare(b.name);
            });

          this.cdr.markForCheck();
        }
      },
      error: err => console.log(err),
    });
  }

  switchAgency(agency: Agency): void {
    this.ls.setItem('agency', agency.name);
    this.ls.setItem('notificationMessage', 'Agency switched');
    window.location.reload();
  }

  search(): void {
    this.queryError = '';
    if (!this.query?.trim()) {
      this.queryError = 'Empty request or session id is not allowed';
      return;
    }

    this.router.navigate(['/search'], {
      queryParams: { q: this.query },
      replaceUrl: true,
    });

    this.query = '';
  }

  private displayStoredNotification(): void {
    const message = this.ls.getItem('notificationMessage');
    if (message) {
      this.toastr.success(message, 'Success');
      this.ls.removeItem('notificationMessage');
    }
  }
}
